module.exports = __webpack_public_path__ + "static/covid-8-d2c48051e5b16d902a72cc877306c99f.png";